export const useQueueStore = defineStore('queueStore', () => {
  const { app } = useRequest();
  const queueStatus = ref(true);

  const setQueueStatusStore = async (newStatus: boolean) => {
    try {
      await app.queueStatusControllerSetQueueStatus({
        running: newStatus,
      });

      queueStatus.value = newStatus;
    } catch {}
  };

  const refreshQueueStatusStore = async () => {
    try {
      const { payload: { running } } = await app.queueStatusControllerGetQueueStatus();

      queueStatus.value = running;
    } catch {}
  };

  return {
    queueStatus,
    setQueueStatusStore,
    refreshQueueStatusStore,
  };
});
